package org.example.willfreightnew.components

import androidx.compose.runtime.Composable
import org.example.willfreightnew.components.models.Service
import org.example.willfreightnew.components.util.Constants.FONT_FAMILY
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text
import org.example.willfreightnew.ServiceCardStyle
import org.jetbrains.compose.web.css.percent
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import org.example.willfreightnew.toSitePalette
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint

@Composable
fun ServiceCard(service: Service) {
    val breakpoint = rememberBreakpoint();
    Column(
        modifier = ServiceCardStyle.toModifier()
            .minWidth(400.px)
            .maxWidth(20.percent)
            .margin(20.px)
            .padding(all = 20.px)
    ) {
        Box(
            modifier = Modifier
                .id("iconBox")
                .align(Alignment.CenterHorizontally)
                .padding(all = 10.px)
                .margin(bottom = 5.px)
                .border(
                    width = 2.px,
                    style = LineStyle.Solid,
                    color = ColorMode.current.toSitePalette().contrastBackground
                )
                .borderRadius(
                    topLeft = 20.px,
                    topRight = 20.px,
                    bottomLeft = 20.px,
                    bottomRight = 0.px
                )

        ) {
            Image(
                modifier = Modifier
                    .id("icon")
                    .size(30.px)
                    .color(Colors.White),
                src = service.icon,
                alt = service.imageDesc,
            )
        }
        P(
            attrs = Modifier
                .id("title")
                .textAlign(TextAlign.Center)
                .fillMaxWidth()
                .margin(top = 5.px, bottom = 10.px)
                .fontFamily(FONT_FAMILY)
                .fontSize(18.px)
                .fontWeight(FontWeight.Bold)
                .toAttrs()
        ) {
            Text(service.title)
        }
        Box(
            modifier = Modifier
                .id("divider-line")
                .align(Alignment.CenterHorizontally)
                .height(1.px)
                .margin(bottom = 10.px)
                .borderRadius(r = 50.px)
        )
        P(
            attrs = Modifier
                .fillMaxWidth()
                .color(ColorMode.current.toSitePalette().brand.primary)
                .margin(top = 0.px, bottom = 0.px)
                .fontFamily(FONT_FAMILY)
                .fontSize(14.px)
                .fontWeight(FontWeight.Light)
                .toAttrs()
        ) {
            Text(service.description)
        }
    }
}